import React, { useState, useEffect } from "react";
import Header from "./Header.js";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import Email from "../assets/mailRed.png";
import GuestIcon from "../assets/guestIcon.png";
import { Modal } from "react-bootstrap";
import MsgBox from "../assets/orngMsg.svg";
import OrngMsg from "../assets/orngMsg.svg";
import DatePicker from "react-datepicker";
import userIcn from "../assets/person_pin_circle.svg";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { Eye, Edit, ArrowLeft } from "lucide-react";
import {
  options_search,
  GuestManagementPageText,
} from "../CommonJquery/WebsiteText.js";
import {
  server_post_data,
  get_all_users,
  update_guest_vip_status,
  get_all_notes_by_id,
  get_user_data_for_edit,
  save_user_data_for_edit,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  handleEmailChange,
  handleNumbersChange,
  formatTimeFormatcustom,
  mondayDayYearFormat,
  computeplussevendays,
  formatDateStringdot,
  goBack,
  formatToYYYYMMDD,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
function MyUserData() {
  const navigate = useNavigate();
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [SelectedData, setSelectedData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const [noteShow2, setNoteShow2] = useState(false);
  const [SelectedDataDetails, setSelectedDataDetails] = useState([]);
  const [StaffImageLinkData, setsStaffImageLinkData] = useState("");
  const [getprimaryid, setprimaryid] = useState();
  const handleSelect = (event) => {
    setSelectedValue(event.target.value); // Update the selected value when an option is selected
  };
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState({
    primary_id: "",
    name: "",
    mobile_no: "",
    email: "",
  });

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    setCurrentPage(1);
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_users, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          seteditStaffData(Response.data.message.data_subscribe);
          console.log(Response.data.message.data_subscribe);
          setfilteredData(Response.data.message.data_subscribe);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_action_update = async (call_id, for_status_final) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();

    fd.append("id_for_delete", call_id);
    fd.append("flag_for", "1");
    fd.append("for_status_final", for_status_final);
    await server_post_data(update_guest_vip_status, fd)
      .then((Response) => {
        setshowLoaderAdmin(false);

        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          closeModal();
          master_data_get(startDate, endDate, flagData, "0");
        }
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);
    setCurrentPage(1);
    // Filter table data based on search value
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          // Add null check here
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };
  const [showModal, setShowModal] = useState(false);
  const [clickedButton, setClickedButton] = useState(null);
  const [showstatus, setshowstatus] = useState("");
  const [selectedGuestIndex, setSelectedGuestIndex] = useState(null);

  const openModal = (guestName, index) => {
    let tesr_show = " Deactivate  ";
    if (guestName.active_status === "0") {
      tesr_show = "Activate ";
    }
    setSelectedData(guestName);
    setShowModal(true);
    setClickedButton(guestName.name);
    setshowstatus(tesr_show);
    setSelectedGuestIndex(index);
  };

  const confirmVIP = (index) => {
    let allow_access_data = "0";
    if (SelectedData.active_status === "0") {
      allow_access_data = "1";
    }
    master_data_action_update(SelectedData.primary_id, allow_access_data);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleShow = (data_call, click_type, index) => {
    master_data_get_ajax(
      data_call.primary_id,
      data_call.primary_id,
      3,
      data_call
    );
  };

  const master_data_get_ajax = async (
    guest_mobile_no,
    reservation_id,
    flag,
    data_call
  ) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("guest_mobile_no", guest_mobile_no);
    fd.append("reservation_id", reservation_id);
    fd.append("flag", flag);
    await server_post_data(get_all_notes_by_id, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setSelectedData(data_call);
          setSelectedDataDetails(Response.data.message.guest_data_data);
          setsStaffImageLinkData(
            APL_LINK + Response.data.message.data_link_image
          );
          setNoteShow2(true);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleNoteClose2 = () => {
    setNoteShow2(false);
  };

  const handleEdit = (id) => {
    navigate(`/Customer-history/${id}`);
  };
  // Open the edit customer modal
  const openEditModal = (customer) => {
    setEditingCustomer({
      primary_id: customer.primary_id,
      name: customer.name,
      mobile_no: customer.mobile_no,
      email: customer.email,
    });
    setShowEditModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };

  // Handle edit input changes
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditingCustomer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const updateCustomerContact = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("customer_id", editingCustomer.primary_id);
    fd.append("mobile_no", editingCustomer.mobile_no);
    fd.append("email", editingCustomer.email);

    await server_post_data(save_user_data_for_edit, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess("Customer details updated successfully");
          closeEditModal();
          master_data_get(startDate, endDate, flagData, "0");
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const handleDateChange = (date) => {
    setStartDate(date);
  };

  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
    const data = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(data, `${fileName}.csv`);
  };

  // Button Component

  const handleDownload = () => {
    // Filter only required fields
    const filteredDataNew = filteredData.map((driver) => ({
      Name: driver.name || "",
      Email: driver.email || "",
      Phone: driver.mobile_no || "",
      "Driving Licence No.": driver.driving_licence || "",
    }));

    exportToCSV(filteredDataNew, "Drivers_List");
  };

  const handleSelectFilter = (e) => {
    const value = e.target.value;

    if (value === "Active") {
      setfilteredData(
        editStaffData.filter((item) => item.booking_status === "Active")
      );
    } else if (value === "InActive") {
      setfilteredData(
        editStaffData.filter((item) => item.booking_status === "InActive")
      );
    } else {
      master_data_get(startDate, endDate, "1", "0");
    }
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="pageNameDiv">
                <p className="breadcrumb-item">Driver Management</p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={handleDownload}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-4 bottomAlgin">
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <select id="selectFilter" onChange={handleSelectFilter}>
                          <option key={"All"} value={"All"}>
                            All
                          </option>
                          <option key={"Active"} value={"Active"}>
                            {"Active"}
                          </option>
                          <option key={"InActive"} value={"InActive"}>
                            {"InActive"}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-5 col-sm-8 bottomAlgin" hidden>
                      <div className="inputDiv2">
                        <img src={Search} alt="Rapid Car Leasing" />
                        <input
                          type="text"
                          id="search_data"
                          onInput={(e) => {
                            if (selectedValue === options_search[0].value) {
                              handleAphabetsChange(e);
                            } else if (
                              selectedValue === options_search[1].value
                            ) {
                              handleEmailChange(e);
                            } else if (
                              selectedValue === options_search[2].value
                            ) {
                              handleNumbersChange(e);
                            }
                          }}
                          placeholder={GuestManagementPageText.Search_Guest}
                        />
                        <button
                          type="button"
                          className="btnSearch"
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          onInput={handleIaphabetnumberChange}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col"> Entry Date</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                  <span className="fontWeight600">
                                    Driver Name
                                    {/* {GuestManagementPageText.Guest_Name} */}
                                  </span>
                                </div>
                              </th>
                              <th scope="col">
                                {" "}
                                {GuestManagementPageText.Contact_Details}
                              </th>
                              {/* <th scope="col">
                                {" "}
                                {GuestManagementPageText.Email_ID}
                              </th> */}
                              <th scope="col">Driving licence</th>
                              <th scope="col">Balance/Dues</th>
                              <th scope="col">Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {mondayDayYearFormat(option.entry_date)}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {option.name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {option.email}
                                      <br />
                                      {option.mobile_no}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {option.driving_licence}
                                    </div>
                                  </td>
                                  {console.log(option.total_advance)}
                                  <td>
                                    <div
                                      className="historyTableRowText historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      <p>
                                        <strong style={{ color: "green" }}>
                                          Total Paid:
                                        </strong>{" "}
                                        ${option?.total_paid || 0}
                                      </p>
                                      <p>
                                        <strong style={{ color: "red" }}>
                                          Due:
                                        </strong>{" "}
                                        ${option?.total_due || 0}
                                      </p>
                                      <p>
                                        <strong style={{ color: "orange" }}>
                                          Advance:
                                        </strong>{" "}
                                        ${option?.balance_advance || 0}
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 "
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "fit-content",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        className={` markVip btn-status m-2 ${
                                          option.booking_status === "Active"
                                            ? "active"
                                            : "inactive"
                                        }`}
                                        // onClick={() => openModal(option, index)}
                                      >
                                        {option.booking_status}
                                      </button>
                                    </div>
                                  </td>

                                  <td>
                                    <div
                                      className="historyActionsBtns height50 mb-2"
                                      style={{ minHeight: "auto" }}
                                    >
                                      <div className="Action_booking_btn">
                                        <Button
                                          className="instructions Add_Instructions"
                                          onClick={() => openEditModal(option)}
                                        >
                                          Edit <Edit size={16} />
                                        </Button>
                                        <Button
                                          className="instructions Add_Instructions"
                                          onClick={() =>
                                            handleEdit(option.primary_id)
                                          }
                                        >
                                          View History{" "}
                                          <Eye
                                            // className="custumer_eye_icon"
                                            size={16}
                                          />
                                        </Button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData && filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                Drivers
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                Driver
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body">
          <div className="success_img d-flex justify-content-center">
            {/* ... Modal content goes here ... */}
          </div>

          <p>
            Are you sure you want to {showstatus}{" "}
            <span style={{ color: "#FF0000" }}> {clickedButton} </span>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="logoutYesBtn"
            onClick={() => confirmVIP(selectedGuestIndex)}
          >
            Yes
          </Button>
          <Button className="logoutNoBtn" onClick={closeModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={noteShow2}
        className="releaseModal modalzindex"
        centered
        onHide={handleNoteClose2}
      >
        <Modal.Header
          style={{ border: "none", paddingBottom: "0" }}
          closeButton
        ></Modal.Header>
        <Modal.Body className="releaseModalBody notesDoby">
          <div className="booking-container">
            <>
              <div className="booking-details">
                <div className="booking-details-label">
                  <label>Notes Details</label>{" "}
                </div>
              </div>

              <div className="guest-details">
                <div className="guest-name-wrapper">
                  <div className="guest-name">{SelectedData.guest_name}</div>
                </div>
              </div>
              {SelectedDataDetails && SelectedDataDetails.length > 0 && (
                <div className="additional-info addtional_notes_css">
                  <div className="info-header">
                    <div className="info_header_container">
                      <div>
                        <img
                          src={OrngMsg}
                          alt="Calendar icon"
                          className="calendar-icon"
                        />
                      </div>

                      <div className="w-100">
                        {SelectedDataDetails &&
                          SelectedDataDetails.map((note, indexsss) => (
                            <>
                              <div key={indexsss} className="info-header-left">
                                <div className="staff-info">
                                  <img
                                    src={StaffImageLinkData + note.staff_image}
                                    onError={(e) => (e.target.src = userIcn)}
                                    alt="Staff avatar"
                                    className="staff-avatar"
                                  />
                                  <div className="staff-name">
                                    {note.staff_name}
                                  </div>
                                </div>
                                <div className="booking-datetime">
                                  {mondayDayYearFormat(note.entry_date)}{" "}
                                  <span
                                    style={{
                                      color: "rgba(245, 134, 52, 1)",
                                    }}
                                  >
                                    I
                                  </span>{" "}
                                  {formatTimeFormatcustom(note.entry_date)}{" "}
                                </div>
                              </div>
                              <div className="info-header-right">
                                <div className="note-item">
                                  {note.note_details}
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          </div>
        </Modal.Body>
      </Modal>
      {/* Edit Customer Modal */}
      <Modal
        show={showEditModal}
        onHide={closeEditModal}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "var(--primary-color)" }}
        >
          <Modal.Title style={{ color: "#fff" }}>
            Edit Driver Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group mb-3">
            <label>Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={editingCustomer.name}
              disabled
              readOnly
            />
            <small className="text-muted">Name cannot be edited</small>
          </div>
          <div className="form-group mb-3">
            <label>Mobile Number</label>
            <input
              type="text"
              className="form-control"
              name="mobile_no"
              value={editingCustomer.mobile_no}
              onChange={handleEditInputChange}
              onInput={handleNumbersChange}
              maxLength={15}
            />
          </div>
          <div className="form-group mb-3">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              disabled
              readOnly
              value={editingCustomer.email}
              onChange={handleEditInputChange}
              onInput={handleEmailChange}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-danger"
            className="btn-cancel"
            style={{
              border: "1px solid #dc3545",
              color: "#dc3545",
              backgroundColor: "transparent",
              borderRadius: "4px",
              padding: "4px 12px",
              fontWeight: "500",
              marginRight: "10px",
            }}
            onClick={closeEditModal}
          >
            Cancel
          </Button>
          <Button
            variant="outline-primary"
            className="btn-save"
            style={{
              border: "1px solid #3C99FF",
              color: "#3C99FF",
              backgroundColor: "transparent",
              borderRadius: "4px",
              padding: "4px 12px",
              fontWeight: "500",
            }}
            onClick={updateCustomerContact}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MyUserData;
